import { Component } from '@angular/core';
import { AppHelperService } from '../../../app/services/app-helper.service';

@Component({
    selector: 'litmus-service-unavailable-screen',
    styleUrls: ['./litmus-service-unavailable-screen.style.scss'],
    templateUrl: './litmus-service-unavailable-screen.template.html',
    standalone: false
})
export class LitmusServiceUnavailableScreen {
  public imageBasePath: string = IMAGES_BASEPATH;
  
  constructor(private appHelperService: AppHelperService) { }

  navigateToDashboard() {
    this.appHelperService.navigateToDashboardApp([]);
  }
}